import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IServerSettings } from '../models/serversettings';
import { StorageManagerService } from './storage-manager.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
    public serverSettings: IServerSettings;

    constructor(private readonly httpService: HttpClient, private storageManagerService: StorageManagerService) { }

  getSettings(): IServerSettings {
        if (!this.serverSettings) {
            const settingsStr = this.storageManagerService.read('appSettings');
            this.serverSettings = settingsStr ? JSON.parse(settingsStr) : {};
            return this.serverSettings;
        } else {
        return this.serverSettings;
        }
    }
    get identityServiceUrl() {
        return this.serverSettings.IdentityServiceUrl;
    }

    get sessionTimout() {
        return this.serverSettings?.SessionTimeout;
    }

    get absoluteSessionTimeout() {
        return this.serverSettings?.AbsoluteSessionTimeout;
    }

    // OneTrust domainTokenId
    get oneTrustDomainToken() {
      return this.serverSettings.OneTrustDomainToken;
    }
}
